document.addEventListener("DOMContentLoaded", function() {

var CollProducts = new Swiper(".coll_products", {
  slidesPerView: 1.1,   // shows part of next slide
  spaceBetween: 12,
  loop: false,
  centeredSlides: false,
  autoHeight: false,
  navigation: {
    nextEl: ".pro_next.swiper-button-next",
    prevEl: ".pro_prev.swiper-button-prev",
  },

  breakpoints: {
    640: {
      slidesPerView: 1.1,
      spaceBetween: 12,
    },
    768: {
      slidesPerView: 3.1,
      spaceBetween: 12,
    },
    1024: {
      slidesPerView: 3.2,   // partial slide visible
      spaceBetween: 24,
    }
  }
});

    var FeatureReview = new Swiper(".Review", {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    });
});
document.addEventListener('shopify:section:load', function (event) {
  CollProducts();
  FeatureReview();
});
